import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum SubstitutionInquiryState {
    OPEN,
    SUBSTITUTE_CONFIRMED,
    CANCELED,
    EXPIRED,
    SUBSTITUTE_AVAILABLE,
}

export namespace SubstitutionInquiryState {
    type Data = {
        text: string;
        icon: string;
        iconColor?: string;
        exportIcon?: string;
    };

    export const Record: Record<SubstitutionInquiryState, Data> = {
        [SubstitutionInquiryState.OPEN]: {
            text: 'Offen',
            icon: 'mdi-account-clock',
            exportIcon: '<span style="color: #0089d3">?</span>',
        },
        [SubstitutionInquiryState.SUBSTITUTE_CONFIRMED]: {
            text: 'Vertretung gefunden',
            icon: 'mdi-check-circle',
            iconColor: 'success',
            exportIcon: '<span style="color: green">✓</span>',
        },
        [SubstitutionInquiryState.CANCELED]: {
            text: 'Abgesagt',
            icon: 'mdi-cancel',
            iconColor: 'error',
            exportIcon: '<span style="color: red">✕</span>',
        },
        [SubstitutionInquiryState.EXPIRED]: {
            text: 'Abgelaufen',
            icon: 'mdi-clock-alert',
            exportIcon: '<span style="color: #777777">!</span>',
        },
        [SubstitutionInquiryState.SUBSTITUTE_AVAILABLE]: {
            text: 'Vertretung verfügbar',
            icon: 'mdi-alert-circle',
            iconColor: 'warning',
            exportIcon: '<span style="color: #ed7227">!</span>',
        },
    };

    export const Items = mapRecordToItems(Record);
}
